import React from 'react'
import HistoryWithWebComponent from './HistoryWebComponent'
import HistoryLegacy from './HistoryLegacy'

export default function (props) {
  const { shouldShowOfferCreationComponent } = props.experienceState
  //adding missing of US1287409 Prevent Component Flow for Consumer Offer Resubmit
  if (shouldShowOfferCreationComponent) {
    return <HistoryWithWebComponent {...props} />
  }
  return <HistoryLegacy {...props} />
}
